const LEAD_CAPTURE_ANSWERS_KEY = "isplink.lead_capture_answers"

function sessionStore() {
  try {
    if (typeof sessionStorage === "undefined" || sessionStorage == null) return null
    // Reading a property catches browsers that throw on storage access.
    void sessionStorage.getItem
    return sessionStorage
  } catch (_e) {
    return null
  }
}

function isValidLeadCaptureEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email == null ? "" : email).trim())
}

function normalizeSignupId(id) {
  return id == null ? "" : String(id).trim()
}

function emptyLeadCaptureAnswers() {
  return {
    email: "",
    how_heard: "",
    how_heard_other: ""
  }
}

function readRawAnswers() {
  try {
    const store = sessionStore()
    if (!store) return null
    return store.getItem(LEAD_CAPTURE_ANSWERS_KEY)
  } catch (_e) {
    return null
  }
}

function writeRawAnswers(json) {
  try {
    const store = sessionStore()
    if (!store) return
    store.setItem(LEAD_CAPTURE_ANSWERS_KEY, json)
  } catch (_e) {
    // Remembering answers must not stop form submission.
  }
}

function readLeadCaptureAnswers() {
  const raw = readRawAnswers()
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== "object") return null
    return parsed
  } catch (_e) {
    return null
  }
}

function presentableAnswers(stored) {
  const source = stored || {}
  return {
    email: isValidLeadCaptureEmail(source.email) ? String(source.email).trim() : "",
    how_heard: source.how_heard == null ? "" : String(source.how_heard).trim(),
    how_heard_other: source.how_heard_other == null ? "" : String(source.how_heard_other).trim()
  }
}

function saveLeadCaptureAnswers(answers) {
  const incoming = answers || {}
  const incomingId = normalizeSignupId(incoming.signup_id)
  const current = readLeadCaptureAnswers() || {}
  const currentId = normalizeSignupId(current.signup_id)
  const replacePreviousSignup = (currentId && !incomingId) || (currentId && incomingId && currentId !== incomingId)
  const base = replacePreviousSignup ? {} : current
  const next = {
    signup_id: incomingId || (replacePreviousSignup ? "" : currentId),
    replaced_signup_id: incomingId ? "" : (replacePreviousSignup ? currentId : normalizeSignupId(base.replaced_signup_id)),
    email: base.email || "",
    how_heard: base.how_heard || "",
    how_heard_other: base.how_heard_other || ""
  }

  if (isValidLeadCaptureEmail(incoming.email)) {
    next.email = String(incoming.email).trim()
  }

  const howHeard = incoming.how_heard == null ? "" : String(incoming.how_heard).trim()
  if (howHeard) {
    next.how_heard = howHeard
    next.how_heard_other = incoming.how_heard_other == null ? "" : String(incoming.how_heard_other).trim()
  } else if (replacePreviousSignup) {
    next.how_heard = ""
    next.how_heard_other = ""
  }

  writeRawAnswers(JSON.stringify(next))
}

function answersBelongToSignup(stored, signupId) {
  if (!stored) return false
  const storedId = normalizeSignupId(stored.signup_id)
  const currentId = normalizeSignupId(signupId)
  const replacedId = normalizeSignupId(stored.replaced_signup_id)
  if (storedId && currentId) return storedId === currentId
  if (storedId && !currentId) return false
  if (!storedId && currentId && replacedId === currentId) return false
  return true
}

function claimSignupId(stored, signupId) {
  const currentId = normalizeSignupId(signupId)
  if (!currentId || !stored || normalizeSignupId(stored.signup_id)) return
  if (normalizeSignupId(stored.replaced_signup_id) === currentId) return
  saveLeadCaptureAnswers({
    email: stored.email,
    how_heard: stored.how_heard,
    how_heard_other: stored.how_heard_other,
    signup_id: currentId
  })
}

function storedLeadCaptureAnswersForForm(signupId) {
  const stored = readLeadCaptureAnswers()
  if (!stored || !answersBelongToSignup(stored, signupId)) return emptyLeadCaptureAnswers()
  claimSignupId(stored, signupId)
  return presentableAnswers(stored)
}

function leadCaptureCanSkip(options) {
  const opts = options || {}
  const stored = storedLeadCaptureAnswersForForm(opts.signupId)
  const emailCaptured = !!opts.emailInForm || !!stored.email
  const howHeardCaptured = !opts.needsHowHeard || !!opts.howHeardInForm || !!stored.how_heard
  return emailCaptured && howHeardCaptured
}

function clearLeadCaptureAnswers(signupId) {
  try {
    const currentId = normalizeSignupId(signupId)
    if (currentId) {
      const stored = readLeadCaptureAnswers()
      if (!stored) return
      const storedId = normalizeSignupId(stored.signup_id)
      if (storedId && storedId !== currentId) return
    }
    const store = sessionStore()
    if (!store) return
    store.removeItem(LEAD_CAPTURE_ANSWERS_KEY)
  } catch (_e) {
    // Clearing answers must not stop the finished-order page.
  }
}

function leadCaptureAnswersToWrite(stored, existing) {
  const cached = presentableAnswers(stored)
  const current = existing || {}
  const existingEmail = isValidLeadCaptureEmail(current.email) ? String(current.email).trim() : ""
  const existingHowHeard = current.how_heard == null ? "" : String(current.how_heard).trim()
  const writeHowHeard = !existingHowHeard && !!cached.how_heard

  return {
    email: existingEmail ? "" : cached.email,
    writeHowHeard: writeHowHeard,
    how_heard: writeHowHeard ? cached.how_heard : "",
    how_heard_other: writeHowHeard ? cached.how_heard_other : ""
  }
}

export {
  readLeadCaptureAnswers,
  saveLeadCaptureAnswers,
  storedLeadCaptureAnswersForForm,
  leadCaptureCanSkip,
  clearLeadCaptureAnswers,
  leadCaptureAnswersToWrite
}
